import axiosInstance from "../axios-instance";
import { getAdminBusinessId, getUserBusinesses } from "./authHelper";

export const ACCOUNT_SETUP_PATH = "/admin/quick-setup-step-one";
export const ACCOUNT_SETUP_CREATE_EVENT_MESSAGE =
  "Please complete your account setup first before creating an event.";

export const resolveAccountSetupBusinessId = () => {
  const stored = getAdminBusinessId();
  if (stored) {
    return stored;
  }
  const businesses = getUserBusinesses();
  if (Array.isArray(businesses) && businesses.length > 0) {
    return businesses[0].id || businesses[0].business_id || null;
  }
  return null;
};

export const parseAccountSetupComplete = (payload) => {
  const body = payload?.data ?? payload ?? {};
  const nested = body.data ?? body;
  return nested.is_complete === true;
};

export const fetchAccountSetupComplete = async () => {
  const businessId = resolveAccountSetupBusinessId();
  if (!businessId) {
    return false;
  }

  try {
    const response = await axiosInstance.get(
      `admin/account-setup-status/${businessId}`
    );
    return parseAccountSetupComplete(response.data);
  } catch (error) {
    return false;
  }
};
